import React from 'react';
import { ToolbarContainer, ToolbarButton } from '../Common/StyledComponents';

const AppToolbar = ({ onAddSection, onAddAll, onRemoveAll, sections }) => {

  const showAddRemoveAll = sections > 0;
  return (
    <ToolbarContainer>
      <ToolbarButton variant="orange" onClick={onAddSection} title="Add New Section">+</ToolbarButton>

      {showAddRemoveAll && (
        <>
          <ToolbarButton variant="orange" onClick={onAddAll} title="Add All Controls">»</ToolbarButton>
          <ToolbarButton variant="red" onClick={onRemoveAll} title="Remove All Controls">«</ToolbarButton>
        </>
      )}
    </ToolbarContainer>
  );
};

export default AppToolbar;